<template>
  <div v-if="firmware && assignRegulationsForm" class="-mx-8">
    <DataTable
        v-model:filters="filters"
        :value="regulations"
        dataKey="id"
        :globalFilterFields="['name']"
        removableSort
    >
      <template #header>
        <div class="flex items-stretch justify-between px-6 space-x-3">
          <IconField iconPosition="left">
            <InputIcon>
              <i class="pi pi-search"/>
            </InputIcon>
            <InputText v-model="filters['global'].value" placeholder="Search Regulations" class="py-2"/>
          </IconField>

          <Button :label="$t('common.save')" @click="submit" v-if="$auth.hasPermission('update:firmware-regulations')"/>
        </div>
      </template>
      <Column field="name" :header="this.$t('pages.admin.firmware.firmware.firmware.regulations.firmware_regulations_view.name')" class="pl-8" sortable></Column>
      <Column field="description" :header="this.$t('pages.admin.firmware.firmware.firmware.regulations.firmware_regulations_view.description')" class="pl-8" sortable></Column>
      <Column style="width: 3rem">
        <template #body="{ data }">
          <Checkbox :value="data" v-model="selectedRegulations"
                    :disabled="!$auth.hasPermission('update:firmware-regulations')"></Checkbox>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import {mapStores} from "pinia";
import {useRegulationsStore} from "@/stores/regulations.js";
import {useForm} from "laravel-precognition-vue";
import {FilterMatchMode} from "primevue/api";
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";

export default {
  name: "FirmwareRegulationsView",
  components: {DevicePropertiesForm},
  data() {
    return {
      loading: true,
      regulations: undefined,
      selectedRegulations: [],
      assignRegulationsForm: undefined,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
      }
    }
  },
  computed: {
    ...mapStores(useRegulationsStore),
    firmware() {
      return this.$attrs.firmware;
    },
  },
  methods: {
    async submit() {
      try {
        this.assignRegulationsForm.regulation_ids = this.selectedRegulations.map(r => r.id);
        await this.assignRegulationsForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.firmware.firmware.firmware.regulations.firmware_regulations_view.regulations_linked_to_firmware'),
          life: 3000
        });
        this.$emit('refresh-firmware')
      } catch (e) {
        this.$toast.add({
          severity: 'info',
          summary: this.$t('common.cancelled'),
          detail: this.$t('pages.admin.firmware.firmware.firmware.regulations.firmware_regulations_view.regulations_were_not_linked_to_firmware'),
          life: 3000
        });
        console.log(e);
      }
    }
  },
  async mounted() {
  },
  watch: {
    'firmware': {
      async handler(newValue, oldValue) {
        if (newValue) {
          try {
            const response = await this.regulationsStore.indexRegulations({per_page: 1000});
            this.regulations = response.data.sort((a, b) => a.name.localeCompare(b.name));
            this.selectedRegulations = this.regulations.filter(r => this.firmware.regulations.some(fr => fr.id === r.id));
            this.assignRegulationsForm = useForm('post', `/firmwares/${this.firmware.id}/regulations`, {
              regulation_ids: this.selectedRegulations.map(r => r.id)
            });
          } catch (e) {
            console.log(e);
            this.regulations = null;
            this.selectedRegulations = null;
            this.assignRegulationsForm = null;
          }
        }
      },
      immediate: true,
    }
  },
}
</script>
